import axios from 'axios';

export const getLiquidCashbackIframeUrl = () => axios.get('/common/cashback/liquid-iframe/');
